import React, { forwardRef } from 'react';
import BaseButton, { BaseButtonProps } from './BaseButton';

interface TextButtonProps extends BaseButtonProps {
  children: React.ReactNode;
}

const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>(({
  children,
  variant = 'primary',
  className = '',
  ...props
}, ref) => {
  return (
    <BaseButton
      ref={ref}
      variant={variant}
      className={`button-text-only ${className}`}
      {...props}
    >
      {children}
    </BaseButton>
  );
});

TextButton.displayName = 'TextButton';

export default TextButton; 